function changeLanguage(params) {
  return {
    type: "SETTINGS__CHANGE_LANGUAGE",
    payload: params
  }
}

export default {
  changeLanguage,
}